import React from 'react';

import { ValidationFeedback, DefaultComponentProps } from '../../types';

import './style.scss';

interface Props extends DefaultComponentProps {
  validationFeedback: ValidationFeedback;
}

export const ValidationSummary = ({ validationFeedback, textConfig }: Props) => {
  return (
    <div className="feedback-summary">
      <h5 className="feedback-summary__title">{textConfig.validationSummary.title}</h5>
      <ul className="feedback-summary__list">
        {validationFeedback.partner && <li className="feedback-summary__item">{validationFeedback.partner}</li>}
        {validationFeedback.phone && <li className="feedback-summary__item">{validationFeedback.phone}</li>}
        {validationFeedback.email && <li className="feedback-summary__item">{validationFeedback.email}</li>}
        {validationFeedback.customerNumber && <li className="feedback-summary__item">{validationFeedback.customerNumber}</li>}
        {validationFeedback.pin && <li className="feedback-summary__item">{validationFeedback.pin}</li>}
      </ul>
    </div>
  );
};
